import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../../Components/Footer/Footer';
import Header from '../../Components/Header/Header';
import InnerHeaderContent from '../../Components/Header/InnerHeaderContent';
import '../../assets/css/Packages.css'
import Testimonials from '../../Components/Home/Testimonials';
import { useDispatch, useSelector } from 'react-redux';
import { GetAllPackages, GetPackageByPagination } from '../../Redux/Auth/Auth_Action';
import { showLoader } from '../../Redux/services/Loader';
import { toast } from 'react-toastify';

const Packages = () => {
    const dispatch = useDispatch();
    const tokenFromRedux = useSelector((state) => state.Auth.token);
    const [packages, setPackages] = useState({ packageItems: [] });
    const [pagination, setPagination] = useState({ paginationData: [] })

    let navigate = useNavigate();

    const PackagesGetAll = () => {
        dispatch(GetAllPackages(tokenFromRedux))
            .then((res) => {
                setPackages({ ...packages, packageItems: res?.data.data })
                // console.log(res?.data);
                setPagination({ ...pagination, paginationData: res?.data.links })
                showLoader("none");
            })
            .catch((e) => {
                console.log(e);
                showLoader("none");
                toast.error("Network Error");
            })
    }

    useEffect(() => {
        PackagesGetAll();
    }, []);

    useEffect(() => {
        window.scroll(0, 0);
    })

    // console.log(packages, 'packages from package')

    const PackagePagination = (url) => {
        dispatch(GetPackageByPagination(url, tokenFromRedux))
            .then((res) => {
                setPackages({ ...packages, packageItems: res?.data.data })
                setPagination({ ...pagination, paginationData: res?.data.links })
                showLoader("none");
            })
            .catch((e) => {
                console.log(e);
                showLoader("none");
                toast.error("Network Error");
            })
    }

    return (
        <div className='about_us packages'>
            <section className='reamining_header_background pos-rel'>
                <Header />
                <InnerHeaderContent pageName={"PACKAGES"} />
            </section>
            <section className='pkg_content'>
                <div className='container'>
                    <div>
                        <h4 className='sub-title mt-5'>Choose your Package </h4>
                        <h2 className='main-title'>Select the package you want the most</h2>
                        <div className="border-btm-pink-secondsec mt-3 mb-4"></div>
                        <p className='main-para mb-5'>I provide various packages for different sports, choose the one that best resonates with you and instead of getting lucky, get smart to win BIG to secure your futures a professional sports bettors’ experience. So choose your package and lock your bets because you are becoming a winner! </p>
                        <p className='main-para mb-5'>Below are my best online game prediction packages.</p>
                    </div>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='crd-flex'>
                                {packages?.packageItems?.map((item, index) => {
                                    // console.log("packaes slub", item);
                                    return (
                                        <div key={index} className='card mx-2 rounded-0 border-0 crd-top-pos h-100'>
                                            <div className='card-body border-0 p-23rem crd-hover-bg tickchange p-white'>
                                                <div className='row'>
                                                    <div className='col-lg-12'>
                                                        <p className='card-title mb-2'>{item?.title}</p>
                                                    </div>
                                                    <div
                                                        dangerouslySetInnerHTML={{ __html: item?.package_offer }}
                                                        className='col-lg-12 text-center dan'>
                                                    </div>
                                                    <div className='flx-bx-price'>
                                                        <div className='row'>
                                                            <div className='col-md-12'>
                                                                <div className='price-container'>
                                                                    <p className='price mr-1'>{item?.price}</p>
                                                                    <p className='delete-price line_over ml-1'> {item?.old_price}</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-12 text-center mt-2'>
                                                                <Link to={"/payment"} state={{ slug: item?.slug, title: item?.title, price: item?.price, limit_intrst: item?.limit_of_interest }}>
                                                                    <button className='btn buyPackage'>
                                                                        BUY THIS PACKAGE
                                                                    </button>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        {/* <div className='col-lg-12 text-center mt-4'>
                            {pagination.paginationData?.map((item, index) => {
                                // console.log(item.active)
                                return (
                                    <button key={index + 100}
                                        onClick={() => { PackagePagination(item.url) }}
                                        disabled={(item.url === null ? true : false)}
                                        className='btn btn-light bt-pagination-all'>
                                        {item.label}
                                    </button>
                                )
                            })}
                        </div> */}
                    </div>
                </div>
            </section>
            <section className='home-bg-seventh pos-rel overflow-hide-x'>
                <div className='bg-testimonial-shahke'>

                </div>
                <div className='container'>
                    <Testimonials />
                </div>
            </section>
            <section className='home-bg-eight'>
                <div className='container'>
                    <div className='join-container'>
                        <p className='sub-title'>What makes Prediction Dog The Big Dog on campus?</p>
                        <h2 className='main-title'>JOIN NOW</h2>
                        <hr className='hr-line' />
                        <p className='para'>With my 36 years of extensive experience in sports betting, I have the skills to properly analyze each game, each line, and each score to give a highly accurate result that will let you make it BIG in the betting world.</p>
                        <div className='btn-container '>
                            <button onClick={() => { window.scroll(0, 700) }} className='btn join-btn border-0 mb-4'>Join Now</button>
                        </div>
                        <p className='para'>
                            {/* As a sports forecaster, every analytics, history, and trend is carefully observed and evaluated to give you the WINNING EDGE and become famous sports bettors! */}
                            As a sports forecaster, every analytics, history and trend is carefully observed and evaluated to give you the winning edge to beat the sports books.
                        </p>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default Packages;
